import React from "react";
import { makeStyles } from '@material-ui/core/styles';
//import Icon from '../../icons/MapPointer'
import Icon from '@material-ui/icons/Room';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles((theme) => ({
	circle: {
  		backgroundColor: '#d83b01',
  		borderRadius: '50%',
  		color: '#fff',
  		height: '2.5em',
  		position: 'relative',
  		width: '2.5em',
		border: '1px solid transparent'
	},
	circleText: {
  		textAlign: 'center',
  		height: '50%',
  		left: '50%',
  		position: 'absolute',
  		top: '50%',
  		transform: 'translate(-50%, -50%)',
  		width: '50%',
	},
	hover: {
  		backgroundColor: '#0078d4',
	},
	pointer : {
		transform: 'translate(-50%, -75%)',
	}
}));
/*
<div onClick={handleClick}>
			<Icon htmlcolor={color ? color : '#02F'} titleAccess={tooltip}>
				{text}
			</Icon>
		</div>
		*/

export default function Circle (props) {
	const classes = useStyles();
	const { //text, 
		tooltip, //$hover, 
		id, color, onClick } = props;
	//const [htmlcolor, setHtmlColor] = React.useState('#02F');
	
  	const handleClick = () => {
    	console.log(`You clicked on ${tooltip}`);
		if(onClick){
			onClick(id);
		}
  	};

	return (
		<Tooltip title={tooltip} placement="top" arrow>
			<IconButton onClick={handleClick} className={classes.pointer}>
				<Icon style={{color: (color ? color : '#05F')}} fontSize="large" />
			</IconButton>
		</Tooltip>
  );
};
